<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import Lucide from "@/components/Base/Lucide";
import { useNotificationsStore } from "@/stores/notifications";
import { storeToRefs } from "pinia";
import { ensurePushSubscription } from "@/utils/pushNotifications";

const props = defineProps<{
  open: boolean;
  setOpen: (v: boolean) => void;
}>();

const { t } = useI18n();
const store = useNotificationsStore();
const { unreadCount, badgeLabel, vapidPublicKey } = storeToRefs(store);

const toggle = async () => {
  const next = !props.open;
  props.setOpen(next);
  if (next) {
    await store.refresh(true);
    void ensurePushSubscription(vapidPublicKey.value);
  }
};

onMounted(() => {
  store.startPolling();
  window.setTimeout(() => {
    void ensurePushSubscription(vapidPublicKey.value);
  }, 2500);
});
onUnmounted(() => store.stopPolling());
</script>

<template>
  <a
    href=""
    class="relative p-2 rounded-full hover:bg-slate-100 dark:hover:bg-darkmode-400"
    :title="t('notifications.header_title')"
    :aria-label="t('notifications.header_title')"
    @click.prevent="toggle"
  >
    <Lucide icon="Bell" class="w-[18px] h-[18px]" />
    <span
      v-if="unreadCount > 0"
      class="absolute -top-0.5 -right-0.5 min-w-[1.1rem] h-[1.1rem] px-1 flex items-center justify-center rounded-full bg-danger text-[10px] font-semibold leading-none text-white"
    >
      {{ badgeLabel }}
    </span>
  </a>
</template>
